import { z } from 'zod'
import type { UserPermissionsGroup } from '../../models/UserPermissionsGroup'
import { mapDTOToUserPermission, mapUserPermissionToDTO, UserPermissionDTO } from '../../../permissions/gateways/DTOs/UserPermisionDTO'
import { mapPdvPermissionToDTO, PdvPermissionDTO, mapDTOToPdvPermission } from '../../../permissions/gateways/DTOs/PdvPermissionDTO'

export const UserPermissionsGroupDTO = z.object({
  id: z.number().optional(),
  name: z.string().nullish(),
  description: z.string().nullish(),
  global: z.boolean().nullish(),
  editable: z.boolean().nullish(),
  permissions: UserPermissionDTO.array().nullish(),
  pdv_permissions: PdvPermissionDTO.array().nullish()
})

const UserPermissionsGroupDTORequest = UserPermissionsGroupDTO.extend({
  permissions: z.array(z.string()).nullish(),
  pdv_permissions: z.array(z.string()).nullish()
})

export type UserPermissionsGroupDTO = z.infer<typeof UserPermissionsGroupDTO>
export type UserPermissionsGroupDTORequest = z.infer<typeof UserPermissionsGroupDTORequest>

export function mapUserPermissionsGroupToDTO (model: UserPermissionsGroup): UserPermissionsGroupDTORequest {
  return {
    id: model.id,
    name: model.name,
    description: model.description,
    global: model.global,
    editable: model.editable,
    permissions: model.permissions?.map(mapUserPermissionToDTO) ?? [],
    pdv_permissions: model.pdvPermissions?.map(mapPdvPermissionToDTO) ?? []
  }
}

export function mapDTOToUserPermissionsGroup (dto: UserPermissionsGroupDTO): UserPermissionsGroup {
  return {
    id: dto.id,
    name: dto.name ?? '',
    description: dto.description ?? '',
    global: dto.global ?? false,
    editable: dto.editable ?? false,
    permissions: dto.permissions?.map(mapDTOToUserPermission) ?? [],
    pdvPermissions: dto.pdv_permissions?.map(mapDTOToPdvPermission) ?? []
  }
}
